import React, { FC, useEffect, useState } from 'react';
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Grid,
    IconButton,
    Tooltip,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { DataQuery } from '../../../services/query';
import { PaymentCommand } from '../../../services/command';
import { SCUIGeneralDrawer, SCUIGeneralModal } from '../../molecules';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { ReturnCardAddDrawerContent } from '../../../pages/Return/CreateReturn/components/ReturnCardAddDrawerContent/ReturnCardAddDrawerContent';
import { ReturnCardEditDrawerContent } from '../../../pages/Return/CreateReturn/components/ReturnCardEditDrawerContent/ReturnCardEditDrawerContent';
import {
    extractCountryListFromPageRulesPayload,
    getReturnPageRulesCountryListCache,
    setReturnPageRulesCountryListCache,
} from '../../../pages/Return/CreateReturn/components/returnPageRules.helper';
import { ReturnQuery } from '../../../services/query';
import Helper from '../../../utils/helper';
import { SCUIButton } from '../SCUIButton/SCUIButton';
//Burasının baştan yazılması gerekiyor.
function mapBankFormToApi(form: any) {
    const { fatherName, ...rest } = form;
    const modifiedFormData = {
        ...rest,
        accountFatherName: fatherName,
    };
    return {
        ...modifiedFormData,
        accountOwner: form.accountOwner || form.accountHolder || form.nameSurname || '',
        bankId: form?.bankSelection?.value || form.bankSelection || form.bankCode || form.bankId || '',
        ibanNumber: form.ibanNumber || form.iban || '',
    };
}

export const SCUICustomerCardModal: FC<{
    callFunction: any;
    open: any;
    onClose?: any;
    customerId?: any;
    buttonText?: string;
}> = ({ callFunction, open, onClose, customerId, buttonText }) => {
    const [bankAccountList, setBankAccountList] = React.useState<any>();
    const [drawerEditOpen, setDrawerEditOpen] = useState(false);
    const [bankList, setBankList] = React.useState<any>();
    const selectedBank: any = undefined;
    const { t } = useTranslation();
    const [selectedBankAccount, setSelectedBnkAccount] = useState<any>();
    const [cardInfo, setCardInfo] = React.useState('registered');
    const [insertBankAccountRequest, setInsertBankAccountRequest] = useState<any>({});
    const [editMode, setEditMode] = useState(false);
    const functionButtonOnClick = () => {
        if (cardInfo === 'registered') {
            callFunction(selectedBankAccount);
        }
        if (validateForm()) {
            if (cardInfo === 'new') {
                InsertBankAccount();
            }
        }
    };
    const validateForm = () => {
        let newErrors: any = {};
        if (selectedBank === undefined) newErrors.bankCode = 'Zorunlu Alan';
        if (selectedBank && selectedBank?.bankCode?.trim().length === 0)
            newErrors.bankCode = t('emailTemplateBuilder.keywordIsRequired');
        return Object.keys(newErrors).length === 0;
    };
    const handleChange = (event: React.MouseEvent<HTMLElement>, cardInfo: string) => {
        setCardInfo(cardInfo);
    };
    const GetBankList = async () => {
        DataQuery.GetBankList().then((res: any) => {
            if (res) setBankList(res?.data?.bankList);
        });
    };

    const prefetchReturnPageRulesCountryList = async () => {
        if (getReturnPageRulesCountryListCache()) return;

        try {
            const response = await ReturnQuery.GetPageRulesList({ CountryId: Helper.GetCurrentCountry() });
            const payload = response?.data || response;
            setReturnPageRulesCountryListCache(extractCountryListFromPageRulesPayload(payload));
        } catch (error) {
            console.error('Error prefetching return page rules country list:', error);
        }
    };

    const GetAcountListByCustomerId = async () => {
        prefetchReturnPageRulesCountryList();
        PaymentCommand.GetBankAccountListByCustomer({
            customerID: customerId,
        }).then((res: any) => {
            if (res) setBankAccountList(res.bankAccountList);
        });
    };

    useEffect(() => {
        GetAcountListByCustomerId();
        GetBankList();
    }, []);

    const DeleteBankAccount = async () => {
        if (selectedBankAccount) {
            Swal.fire({
                text: t('general.deleteConfirmationText'),
                cancelButtonText: t('general.cancel'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: t('general.delete'),
            }).then((result: any) => {
                if (result.isConfirmed) {
                    let params: any = {};
                    params.bankAccount = selectedBankAccount;
                    params.customerId = customerId;
                    params.bankAccount.status = false;
                    PaymentCommand.DeleteCustomerBankAccount(params).then((res: any) => {
                        if (res && res.result) {
                            GetAcountListByCustomerId();
                        } else {
                            Swal.fire(' ', ' ', 'error');
                        }
                    });
                }
            });
        } else Swal.fire(t('customerInformation.deleteSelectAccount'), ' ', 'error');
    };

    const InsertBankAccount = async () => {
        let params: any = {
            bankAccount: mapBankFormToApi(insertBankAccountRequest),
            customerId: customerId,
        };
        // IBAN ve Hesap Numarasını boşluksuz gönder
        if (params.bankAccount.ibanNumber) {
            params.bankAccount.ibanNumber = params.bankAccount.ibanNumber.replace(/\s/g, '');
        }

        PaymentCommand.InsertCustomerBankAccount(params)
            .then(() => {
                setInsertBankAccountRequest({});
                Swal.fire({
                    icon: 'success',
                    title: '',
                    showConfirmButton: false,
                    timer: 1500,
                });
                GetAcountListByCustomerId();
                setCardInfo('registered');
            })
            .catch((error: any) => {
                Swal.fire({
                    icon: 'error',
                    title: error.data,
                    showConfirmButton: false,
                    timer: 1500,
                });
            });
    };

    const UpdateBankAccount = async (formData: any) => {
        let params: any = {
            bankAccount: mapBankFormToApi(formData),
            customerId: customerId,
        };
        // IBAN ve Hesap Numarasını boşluksuz gönder
        if (params.bankAccount.ibanNumber) {
            params.bankAccount.ibanNumber = params.bankAccount.ibanNumber.replace(/\s/g, '');
        }
        PaymentCommand.UpdateCustomerBankAccount(params)
            .then(() => {
                setEditMode(false);
                setDrawerEditOpen(false);
                Swal.fire({
                    icon: 'success',
                    title: '',
                    showConfirmButton: false,
                    timer: 1500,
                });
                GetAcountListByCustomerId();
            })
            .catch((error: any) => {
                Swal.fire({
                    icon: 'error',
                    title: error.data,
                    showConfirmButton: false,
                    timer: 1500,
                });
            });
    };

    return (
        <SCUIGeneralModal
            disabled={drawerEditOpen}
            open={open}
            onClose={onClose}
            width={'lg'}
            title={t('customerInformation.bankAccountSelect')}
        >
            <Grid container sx={{ lineHeight: 1.5, padding: '16px' }} spacing={2}>
                <SCUIGeneralDrawer
                    open={drawerEditOpen || editMode}
                    onClose={(_: any, reason: any) => {
                        if (reason === 'backdropClick') {
                            setDrawerEditOpen(false);
                            setEditMode(false);
                        }
                    }}
                    width={'400px'}
                >
                    <ReturnCardEditDrawerContent
                        bankList={bankList}
                        selectedBankAccount={selectedBankAccount}
                        onClose={() => {
                            setDrawerEditOpen(false);
                            setEditMode(false);
                        }}
                        onUpdateBankAccount={(success: boolean, formData: any) => {
                            if (success) {
                                UpdateBankAccount(formData);
                            }
                        }}
                    />
                </SCUIGeneralDrawer>
                <Grid
                    sx={{ marginBottom: 2 }}
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <ToggleButtonGroup
                        color="primary"
                        fullWidth
                        value={cardInfo}
                        exclusive
                        onChange={handleChange}
                        aria-label="Platform"
                    >
                        <ToggleButton value="registered">{t('customerInformation.registeredAccount')}</ToggleButton>
                        <ToggleButton value="new">{t('customerInformation.addAccountRegistration')}</ToggleButton>
                    </ToggleButtonGroup>
                </Grid>
                {cardInfo === 'registered' && (
                    <>
                        <Grid container sx={{ lineHeight: 1.5, padding: 1, width: '100%' }} spacing={2}>
                            {bankAccountList &&
                                bankAccountList.map((bankAccount: any) => {
                                    const isSelected =
                                        selectedBankAccount &&
                                        selectedBankAccount.bankAccountId === bankAccount.bankAccountId;
                                    return (
                                        <Grid
                                            key={bankAccount.bankAccountId}
                                            size={{
                                                xl: 6,
                                                lg: 6,
                                                sm: 12,
                                                xs: 12,
                                            }}
                                        >
                                            <Card
                                                onClick={() => setSelectedBnkAccount(bankAccount)}
                                                sx={{
                                                    cursor: 'pointer',
                                                    borderRadius: '12px',
                                                    border: isSelected ? '2px solid #1976d2' : '1.5px solid #e0e0e0',
                                                    boxShadow: isSelected
                                                        ? '0 4px 20px rgba(25, 118, 210, 0.18)'
                                                        : '0 2px 8px rgba(0,0,0,0.07)',
                                                    backgroundColor: isSelected ? '#f0f7ff' : '#fff',
                                                    transition:
                                                        'box-shadow 0.2s ease, border-color 0.2s ease, background-color 0.2s ease, transform 0.15s ease',
                                                    '&:hover': {
                                                        boxShadow: '0 6px 24px rgba(0,0,0,0.13)',
                                                        borderColor: isSelected ? '#1565c0' : '#90caf9',
                                                        transform: 'translateY(-2px)',
                                                    },
                                                }}
                                            >
                                                <CardHeader
                                                    avatar={
                                                        <AccountBalanceIcon
                                                            sx={{
                                                                color: isSelected ? '#1976d2' : '#78909c',
                                                                fontSize: 28,
                                                                transition: 'color 0.2s ease',
                                                            }}
                                                        />
                                                    }
                                                    title={
                                                        <Typography
                                                            noWrap
                                                            variant="subtitle1"
                                                            fontWeight={700}
                                                            color={isSelected ? 'primary.main' : 'text.primary'}
                                                            sx={{ letterSpacing: 0.2 }}
                                                        >
                                                            {bankAccount.bankName} {bankAccount.bankCode}
                                                        </Typography>
                                                    }
                                                    sx={{ pb: 0 }}
                                                />
                                                <CardContent sx={{ pt: 1 }}>
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            fontFamily: 'monospace',
                                                            fontSize: '0.78rem',
                                                            color: '#546e7a',
                                                            letterSpacing: 0.5,
                                                            mb: 0.5,
                                                        }}
                                                    >
                                                        {bankAccount.ibanNumber}
                                                    </Typography>
                                                    <Typography
                                                        variant="body2"
                                                        fontWeight={600}
                                                        color="text.primary"
                                                        sx={{ mb: 0.25 }}
                                                    >
                                                        {bankAccount.accountOwner}
                                                    </Typography>
                                                    {bankAccount.accountNumber && (
                                                        <Typography
                                                            variant="caption"
                                                            color="text.secondary"
                                                            sx={{ display: 'block', mb: 1 }}
                                                        >
                                                            {bankAccount.accountNumber}
                                                        </Typography>
                                                    )}
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            gap: 1,
                                                            mt: 1,
                                                            pt: 1,
                                                            borderTop: '1px solid #f0f0f0',
                                                        }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <Tooltip title={t('general.edit')} arrow>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => {
                                                                    setSelectedBnkAccount(bankAccount);
                                                                    setEditMode(true);
                                                                }}
                                                                sx={{
                                                                    color: '#2e7d32',
                                                                    border: '1px solid #c8e6c9',
                                                                    borderRadius: '8px',
                                                                    padding: '4px 10px',
                                                                    gap: 0.5,
                                                                    fontSize: '0.78rem',
                                                                    fontWeight: 600,
                                                                    transition:
                                                                        'background-color 0.18s ease, box-shadow 0.18s ease',
                                                                    '&:hover': {
                                                                        backgroundColor: '#e8f5e9',
                                                                        boxShadow: '0 2px 8px rgba(46,125,50,0.15)',
                                                                        borderColor: '#66bb6a',
                                                                    },
                                                                }}
                                                            >
                                                                <EditIcon sx={{ fontSize: 15 }} />
                                                                <span>{t('general.edit')}</span>
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title={t('general.delete')} arrow>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => {
                                                                    setSelectedBnkAccount(bankAccount);
                                                                    DeleteBankAccount();
                                                                }}
                                                                sx={{
                                                                    color: '#c62828',
                                                                    border: '1px solid #ffcdd2',
                                                                    borderRadius: '8px',
                                                                    padding: '4px 10px',
                                                                    gap: 0.5,
                                                                    fontSize: '0.78rem',
                                                                    fontWeight: 600,
                                                                    transition:
                                                                        'background-color 0.18s ease, box-shadow 0.18s ease',
                                                                    '&:hover': {
                                                                        backgroundColor: '#ffebee',
                                                                        boxShadow: '0 2px 8px rgba(198,40,40,0.15)',
                                                                        borderColor: '#ef9a9a',
                                                                    },
                                                                }}
                                                            >
                                                                <DeleteIcon sx={{ fontSize: 15 }} />
                                                                <span>{t('general.delete')}</span>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    );
                                })}
                        </Grid>
                        <Grid container justifyContent="flex-end">
                            <SCUIButton
                                type={'primary'}
                                sizeType={'icon'}
                                size={'m'}
                                text={buttonText || t('refund.updateCalculation')}
                                onClick={() => functionButtonOnClick()}
                                buttonType="button"
                            />
                        </Grid>
                    </>
                )}
                {cardInfo === 'new' && (
                    <Box
                        sx={{
                            width: '100%',
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: 'flex',
                        }}
                    >
                        <ReturnCardAddDrawerContent
                            insertBankAccountRequest={insertBankAccountRequest}
                            setInsertBankAccountRequest={setInsertBankAccountRequest}
                            InsertBankAccount={InsertBankAccount}
                            onClose={onClose}
                        />
                    </Box>
                )}
            </Grid>
        </SCUIGeneralModal>
    );
};
